import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { DepotDeleted, deleteDepot } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useDeleteDepot = (
  options: UseMutationOptions<DepotDeleted, unknown, number, unknown>
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => extractData(deleteDepot({ path: { id } })),
    ...options,
    onSuccess(...args) {
      queryClient.invalidateQueries({
        queryKey: ['depots'],
      });
      options.onSuccess?.(...args);
    },
  });
};
